import { AuctionTypeEnum, AuctionDetailsInterface, AuctionStatusEnum } from '@on-arte/core-types';

export function getItemActiveAuctionPerTypes(
  auctions: AuctionDetailsInterface[], types: AuctionTypeEnum[]
): AuctionDetailsInterface | undefined {
  return auctions
    .find((auction: AuctionDetailsInterface): boolean => auction.status === AuctionStatusEnum.Active && types.includes(auction.type));
}
